// libs
import React, { useCallback, useContext, memo } from "react";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

// defs
import type { EMIWidgetLineItem, ProductDetailsHalfCardInfo } from "@payment-client/interfaces/Checkout";

// styled
import { Cell, SubText, Row } from "./styled";

// hooks
import { useEffectOnce } from "@swiggy-private/core-ui";

// utils
import { isEmpty } from "@swiggy-private/js-utils";
import { clickEmiDetails } from "@payment-client/components/show-payments/components/review-bill-details-renderer/helpers/analytics";

// contexts
import { AnalyticsContext } from "@swiggy-private/checkout-core";

interface IProps {
    lineItem: EMIWidgetLineItem;
    setProductDetails: (productDetails?: ProductDetailsHalfCardInfo) => void;
    captureImpression: (payload: any) => void;
}

const EMILineItem = ({ lineItem, setProductDetails, captureImpression }: IProps) => {
    const { clickEvent } = useContext(AnalyticsContext);
    useEffectOnce(() => {
        captureImpression(lineItem.analytics);
    });

    const handleProductDetailsClick = useCallback(
        (productDetails?: ProductDetailsHalfCardInfo) => {
            clickEmiDetails(clickEvent);
            setProductDetails(productDetails);
        },
        [clickEvent, setProductDetails],
    );

    const getTextStyles = (dlsColor?: string) => {
        if (!isEmpty(dlsColor)) {
            return { color: dlsColor };
        }

        return {};
    };

    return (
        <Row>
            {lineItem.items.map((cell) => {
                const { details, subtextDetails } = cell.displayContent;
                const text = details[0]?.text?.content;
                const subtext = subtextDetails?.details[0]?.text?.content;
                const halfCardInfo = subtextDetails?.halfCardInfo;

                return (
                    <Cell key={text}>
                        <Text
                            variant="V2.body2.neutral.regular"
                            color="text_Med_Emphasis"
                            style={getTextStyles(details?.[0]?.text?.dlsColor)}
                        >
                            {text}
                        </Text>
                        {subtext && (
                            <SubText
                                variant="V2.overline.neutral.regular"
                                color="text_Low_Emphasis"
                                onClick={() => handleProductDetailsClick(halfCardInfo)}
                            >
                                {subtext}
                            </SubText>
                        )}
                    </Cell>
                );
            })}
        </Row>
    );
};

export default memo(EMILineItem);
